import React from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

import CardInfoList from "./CardInfoList";
import CardPermissions from "./CardPermissions";
import useTabs from "../../../components/TabsBar/useTabs";
import TabPanel from "../../../components/TabsBar/TabPanel";
import TabsBar from "../../../components/TabsBar";

import Grid from "@mui/material/Grid";
import MDBox from "../../../materialDashboard/components/MDBox";


const Group = () => {
    const {t} = useTranslation(['groups']);
    const {groupId} = useParams();

    const tabs = useTabs({tabs: [
            {label: t("group.tabs.info"), icon: "edit"},
            {label: t("group.tabs.rules"), icon: "rule"},
        ], defaultTabIndex: 1});

    return <MDBox mx={2} sx={{mt: 4}}>
        <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={5} lg={4} sx={{ ml: "auto" }}>
                <TabsBar {...tabs}/>
            </Grid>
        </Grid>
        <TabPanel value={tabs.tabValue} index={0}>
            <CardInfoList/>
        </TabPanel>
        <TabPanel value={tabs.tabValue} index={1}>
            <CardPermissions groupId={parseInt(groupId)}/>
        </TabPanel>
    </MDBox>
}

export default Group;